module.exports = "../../../../platform/assets/pageMainIcon/ig-business-setting-1.svg";